import { colors } from '@cabonline/ui-shared';
import { Button } from '@cabonline/ui-web';
import { Menu as MenuIcon, PersonOutlineRounded } from '@mui/icons-material';
import { useAuth, useLocale } from '@multiplatform-apps/service-trips';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { paths } from '../../../constants';
import { ENABLE_NOTIFICATIONS } from '../../../constants/feature-toggles';
import { useMenu } from '../../../context';
import { useIndexPermissions } from '../../../hooks';
import { Menu } from '../menu/menu';
import { NotificationBell } from '../notification-bell';
import { StyledLinkContainer } from './styles';
import { ProfileIdentity } from './types';

const getCanSeeNotifications = (
  isAuthenticated: boolean,
  canSeeNotificationsMenuItem: boolean | undefined
): boolean => isAuthenticated && ENABLE_NOTIFICATIONS && !!canSeeNotificationsMenuItem;

const getProfileLabel = (identity: ProfileIdentity | null | undefined): string | undefined =>
  identity?.firstName || identity?.displayName;

export const TabletNavbar: FC = () => {
  const { isMenuOpen, setIsMenuOpen } = useMenu();
  const { isAuthenticated, identity } = useAuth();
  const { t } = useLocale();
  const navigate = useNavigate();
  const indexPermissions = useIndexPermissions();

  const canSeeNotifications = getCanSeeNotifications(isAuthenticated, indexPermissions?.canSeeNotificationsMenuItem);
  const profileLabel = getProfileLabel(identity);
  const profileAriaLabel = profileLabel || t('navBar.profile');

  const handleProfileButtonPress = () => {
    setIsMenuOpen(false);
    navigate(paths.profile.root);
  };

  const handleMenuButtonPress = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <StyledLinkContainer>
        <Button
          variant="secondary"
          label={t('tabletMenu.label')}
          onClick={handleMenuButtonPress}
          iconLeft={<MenuIcon aria-hidden={true} htmlColor={colors.primary} />}
        />

        {canSeeNotifications && <NotificationBell />}
        {isAuthenticated && (
          <Button
            variant="primary"
            label={profileLabel}
            aria-label={profileAriaLabel}
            onClick={handleProfileButtonPress}
            iconLeft={<PersonOutlineRounded aria-hidden={true} />}
          />
        )}
      </StyledLinkContainer>

      {isMenuOpen && <Menu closeMenu={handleMenuClose} />}
    </>
  );
};
